export const buildZmyleColor = (color: ZmyleColor): string => {
  const { red, green, blue, alpha } = color;

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export const parseRgbaToHEX = (rgba: string): string => {
  const matches = rgba.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/i);

  if (!matches) return rgba;

  const r = parseInt(matches[1], 10);
  const g = parseInt(matches[2], 10);
  const b = parseInt(matches[3], 10);
  const a = Math.round(parseFloat(matches[4]) * 255);
  const hexR = r.toString(16).padStart(2, '0');
  const hexG = g.toString(16).padStart(2, '0');
  const hexB = b.toString(16).padStart(2, '0');
  const hexA = a.toString(16).padStart(2, '0');

  return `#${hexR}${hexG}${hexB}${hexA}`;
};

const isValidHex = (hex: string) => /^#([0-9A-F]{3}){1,2}$/i.test(hex);

const hexToRgb = (hex: string) => {
  const bigint = parseInt(hex.slice(1), 16);

  const r = Math.floor(bigint / (256 * 256)) % 256;
  const g = Math.floor(bigint / 256) % 256;
  const b = bigint % 256;

  return { r, g, b };
};

const rgbToHex = (r: number, g: number, b: number) => {
  const toHex = (n: number) => Math.round(n).toString(16).padStart(2, '0');

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const lighten = (color: string, percentage: number): string => {
  if (!isValidHex(color)) return color;

  if (percentage < 0 || percentage > 1) return color;

  const { r, g, b } = hexToRgb(color);

  const lightenValue = (value: number) =>
    Math.max(0, Math.min(255, value + (255 - value) * percentage));

  const newR = lightenValue(r);
  const newG = lightenValue(g);
  const newB = lightenValue(b);

  return rgbToHex(newR, newG, newB);
};
